<!-- ng form for dates-group timers -->
<form
  (ngSubmit)="onSubmitFormValues()"
  [formGroup]="form"
  [patchForm]="bookingDetails"
>
  <div class="row mb-4">
    <div class="col-12 col-md-3">
      <label class="h5 col-form-label">{{
        'bookingModule.targetGroup' | translate
      }}</label>
    </div>

    <div class="col-12 col-md-9">
      <div class="btn-group w-100" *ngIf="member$ | async">
        <button
          (click)="form.controls['targetGroup'].setValue(group.value)"
          *ngFor="let group of targetGroupsOptions"
          [ngClass]="{
            active: form.get('targetGroup').value === group.value
          }"
          class="btn-soft-primary btn"
          type="button"
        >
          <span class="d-flex flex-column">
            <i role="img" [ngClass]="group.icon" aria-hidden="true"></i>
            <span>{{ group.label | translate }}</span>
          </span>
        </button>
      </div>
      <div
        *ngIf="
          form.controls.targetGroup.dirty && form.controls.targetGroup.invalid
        "
        class="invalid-feedback"
        role="alert"
        aria-atomic="true"
      >
        {{ 'general.isInvalid' | translate }}
      </div>
    </div>
  </div>

  <div class="row mb-4">
    <div class="col-12 col-md-3">
      <label class="h5 col-form-label">{{
        'bookingModule.isSleepOver' | translate
      }}</label>
    </div>

    <div class="col-12 col-md-9">
      <div class="btn-group-segment">
        <button
          (click)="form.controls['isSleepOver'].setValue(true)"
          [ngClass]="{
            active: form.get('isSleepOver').value,
            'btn-outline': !form.get('isSleepOver').value
          }"
          class="btn"
          type="button"
        >
          {{ 'general.yes' | translate }}
        </button>
        <button
          (click)="form.controls['isSleepOver'].setValue(false)"
          [ngClass]="{
            active: !form.get('isSleepOver').value,
            'btn-outline': form.get('isSleepOver').value
          }"
          class="btn"
          type="button"
        >
          {{ 'general.no' | translate }}
        </button>
      </div>
    </div>
  </div>

  <div [hidden]="!form.get('isSleepOver').value" class="row mb-4">
    <div class="col-12 col-md-3">
      <label class="h5 col-form-label">{{
        'bookingModule.is75SleepOver' | translate
      }}</label>
    </div>

    <div class="col-12 col-md-9">
      <div class="btn-group-segment">
        <button
          (click)="form.controls['is75SleepOver'].setValue(true)"
          [ngClass]="{
            active: form.get('is75SleepOver').value
          }"
          class="btn"
          type="button"
        >
          {{ 'general.yes' | translate }}
        </button>
        <button
          (click)="form.controls['is75SleepOver'].setValue(false)"
          [ngClass]="{
            active: !form.get('is75SleepOver').value
          }"
          class="btn"
          type="button"
        >
          {{ 'general.no' | translate }}
        </button>
      </div>
    </div>
  </div>
  <div class="row mb-4">
    <div class="col-12 col-md-3">
      <label class="h5 col-form-label">{{ 'general.dates' | translate }}</label>
    </div>

    <div class="col-12 col-md">
      <div class="list-group">
        <div class="list-group-item">
          <div class="row">
            <div class="col-12 col-lg-4 align-self-center">
              <label class="col-form-label">{{
                'bookingModule.arrivalDeparture' | translate
              }}</label>
            </div>
            <div class="col-12 col-md">
              <nz-date-picker
                #startDatePicker
                class="me-3"
                [nzDisabledDate]="disabledStartDate"
                formControlName="startDate"
                [nzPlaceHolder]="'general.startDate' | translate"
                [nzSize]="'large'"
                (nzOnOpenChange)="handleStartOpenChange($event)"
              ></nz-date-picker>
              <nz-date-picker
                #endDatePicker
                [nzDisabledDate]="disabledEndDate"
                formControlName="endDate"
                [nzPlaceHolder]="'general.endDate' | translate"
                [nzSize]="'large'"
                (nzOnOpenChange)="handleEndOpenChange($event)"
              ></nz-date-picker>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row mb-4" [hidden]="!form.get('isSleepOver').value">
    <div class="col-12 col-md-3">
      <label class="h5 col-form-label">{{
        'bookingModule.groupDetails' | translate
      }}</label>
    </div>
    <div class="col-12 col-md">
      <div class="list-group" formGroupName="participants">
        <div [hidden]="!form.get('isSleepOver').value" class="list-group-item">
          <div class="row">
            <label
              class="col-6 col-lg-4 align-self-center"
              for="numberSleepOver"
            >
              {{ 'bookingModule.numberParticipantsSleepingOver' | translate }}
              <span
                class="text-danger"
                attr.aria-label="{{ 'general.required' | translate }}"
                *ngIf="
                  form.get('participants')?.get('numberSleepOver')?.errors
                    ?.required
                "
              >
                *
              </span>
            </label>
            <div class="col col-lg-4 col-lg-3">
              <input
                [attr.aria-invalid]="
                  form.get('participants')?.get('numberSleepOver')?.invalid &&
                  form.get('participants')?.get('numberSleepOver')?.dirty
                    ? 'true'
                    : null
                "
                class="form-control"
                [placeholder]="'Max ' + sleepingOverMax"
                [max]="sleepingOverMax"
                formControlName="numberSleepOver"
                id="numberSleepOver"
                type="number"
                [required]="
                  form.get('participants')?.get('numberSleepOver')?.errors
                    ?.required
                "
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-5">
    <div class="offset-md-3 col-md">
      <button
        class="btn btn-primary w-100 d-block d-flex justify-content-center"
        type="submit"
        [disabled]="isLoading"
      >
        {{ 'bookingModule.continue' | translate }}
        <span
          class="spinner-border spinner-border-sm"
          role="status"
          [hidden]="!isLoading"
          attr.aria-label="{{ 'general.loading' | translate }}"
        >
        </span>
      </button>
    </div>
  </div>
</form>
